import * as StyledSystem from 'styled-system';
export var customStyleProps = {
  shadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  fill: {
    property: 'fill',
    scale: 'colors'
  },
  stroke: {
    property: 'stroke',
    scale: 'colors'
  },
  textDecoration: true,
  textTransform: true,
  animation: true,
  transform: true,
  visibility: true,
  whiteSpace: true,
  pointerEvents: true,
  wordBreak: true,
  overflowWrap: true,
  textOverflow: true,
  cursor: true,
  resize: true,
  transition: true,
  objectFit: true,
  outline: true,
  willChange: true,
  userSelect: true,
  borderCollapse: true,
  borderSpacing: true,
  tableLayout: true,
  transformOrigin: true
};
export var stylingProps = StyledSystem.compose(StyledSystem.space, StyledSystem.color, StyledSystem.layout, StyledSystem.background, StyledSystem.grid, StyledSystem.shadow, StyledSystem.border, StyledSystem.position, StyledSystem.flexbox, StyledSystem.borderRadius, StyledSystem.typography, StyledSystem.system(customStyleProps)); // All of the allowed props gathered together